import {AbstractView} from "../../../views/AbstractView";
import {ISsoRedirectController, IT_SSO_REDIRECT_CONTROLLER} from "../_controllers/ISsoRedirectController";
import {Component, OnInit} from "@angular/core";
import {SsoRedirectController} from "../_controllers/sso-redirect.controller";

@Component({
  selector: 'link-sso-redirect',
  templateUrl: './sso-redirect.view.html',
  styleUrls: ['./sso-redirect.view.scss'],
  providers: [
    { provide: IT_SSO_REDIRECT_CONTROLLER, useClass: SsoRedirectController },
  ]
})
export class SsoRedirectView extends AbstractView<ISsoRedirectController> implements OnInit {

  constructor() {
    super(IT_SSO_REDIRECT_CONTROLLER);
  }

  ngOnInit() {
    this.handle('Init');
  }
}
